import { useState, useEffect } from 'react';
import HealthOverviewContext from './HealthOverviewContext';
import { SpaceIOService } from 'auth-utils'
import { Tooltip, Tag } from 'freespace-react-components';
import 'primeicons/primeicons.css';


import axios from 'axios';

const HealthOverviewProvider = ({ children }) => {

    const [devicesInfo, setDevicesInfo] = useState(null);
    // const [locationsInfo, setLocationsInfo] = useState(null)

    // const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [productType, setProductType] = useState(null);

    const authKey = localStorage.getItem('spaceio-key');
    const floorId = localStorage.getItem('FloorId');


    const DevicesDetails = async (floorId) => {
        const init = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.PROD_WS_BASE_URL}/api/admin/locations/${floorId}/devices`,
            headers: {
                'authorization': `bearer ${authKey}`,
            }
        };
        try {
            const response = await SpaceIOService.request(`${process.env.PROD_WS_BASE_URL}/api/admin/locations/${floorId}/devices`, init);
            const responseData = await response.json();
            return responseData;
        } catch (error) {
            console.error('An error occurred in the axios request:', error);
        }
    };

    const productDetails = async () => {
        const init = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.PROD_WS_BASE_URL}/api/admin/searchProducts`,
            headers: {
                'authorization': `bearer ${authKey}`,
            }
        };
        try {
            const response = await SpaceIOService.request(`${process.env.PROD_WS_BASE_URL}/api/admin/searchProducts`, init);
            const responseData = await response.json();
            return responseData;
        } catch (error) {
            console.error('An error occurred in the axios request:', error);
        }
    }

    const transformData = (data, productWiseDetails, healthDataArrayInfo) => {
        // console.log("Transform Data - input data:", data);
        // console.log("Transform Data - input healthDataArrayInfo:", healthDataArrayInfo);
        return data.map(item => {
            const productId = item?.assignedSpace?.device?.hardware?.productId || '';
            const matchedProduct = productWiseDetails.find(product => product.id === productId);

            let healthData = null;

            if (productType.includes('ONE')) {
                healthData = healthDataArrayInfo.filter((data) => data.id === item.networkData?.assetId)
            } else {
                healthData = healthDataArrayInfo.filter((data) => data.id === item.assignedSpace?.assetId);
            }

            return {
                'Product': matchedProduct ? matchedProduct.name : productId,
                'Install ID': item?.id || '',
                'Serial ID': item?.assignedSpace?.device?.blessId || '',
                'Space Name': item?.displayName || '',
                'Marker ID': item?.assignedSpace?.serial || '',
                'Category': item?.assignedSpace?.category.name || '',
                'Space ID': item?.assignedSpace?.id || '',
                'Presence': healthData[0]?.lastPresence,
                'Heart Beat': healthData[0]?.heartbeatAck,
                'Last Frame': healthData[0]?.lastFrame,
                'I2C Error': healthData[0]?.i2cError,
                'Network': healthData[0]?.wifiPara, // .length > 0 ? healthData[0]?.wifiPara[1] : '',
                // 'RSSI': healthData[0]?.wifiPara, //.length > 0 ? healthData[0]?.wifiPara[0] : '',
                'Build': healthData[0]?.buildVersion,
                'TOy': item?.networkData?.network?.incidentsOfTimeoutsYesterday || '0',
                'TOt': item?.networkData?.network?.incidentsOfTimeoutsToday || '0',
                'Risk': '',
                // <div style={{
                //     // background: 'white',
                //     width: '150px',
                //     display: 'flex',
                //     gap: '20px',
                //     marginLeft: '10px',
                //     marginRight: '10px',
                //     justifyContent: 'start',
                //     alignItems: 'center'
                // }}>
                //     <Tag value={'Low'} severity={'success'}></Tag>
                //     <i className="pi pi-file" style={{ fontSize: '14px', color: '#1FA868' }}></i>
                //     <i className="pi pi-calendar" style={{ fontSize: '14px', color: '#1FA868' }}></i>
                //     <i className="pi pi-eye" style={{ fontSize: '14px', color: '#1FA868' }}></i>
                //     <i className="pi pi-refresh" style={{ fontSize: '14px', color: '#1FA868' }}></i>
                // </div>,
            };
        });
    };

    const LocationDetails = async () => {

        // sapce Asset Id
        const init = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.PROD_WS_BASE_URL}/api/locations?detailed=false`,
            headers: {
                'authorization': `bearer ${authKey}`,
            }
        };
        try {
            const response = await SpaceIOService.request(`${process.env.PROD_WS_BASE_URL}/api/locations?detailed=false`, init);
            const responseData = await response.json();
            return responseData;
        } catch (error) {
            console.error('An error occurred in the axios request:', error);
        }
    };

    const networkDeviceDetails = async (floorId) => {

        // Device Asset Id 
        const init = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.PROD_WS_BASE_URL}/api/locations/${floorId}/raw-devices`,
            headers: {
                'authorization': `bearer ${authKey}`,
            }
        };
        try {
            const response = await SpaceIOService.request(`${process.env.PROD_WS_BASE_URL}/api/locations/${floorId}/raw-devices`, init);
            const responseData = await response.json();
            return responseData;
        } catch (error) {
            console.error('An error occurred in the axios request:', error);
        }
    };

    const fetchHealth = async (arrayOfFloorAssetId: string[]) => {
        if (arrayOfFloorAssetId.length > 0) {
            let data = JSON.stringify(arrayOfFloorAssetId);
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${process.env.SPOT_BASE_URL}/assets/data/10/current`,
                headers: {
                    'authorization': `bearer ${authKey}`,
                },
                data: data
            };
            try {
                const response = await axios.request(config);
                // console.log(response.data);
                return response.data;
            } catch (error) {
                console.error('An error occurred in the axios request:', error);
            }
        }
        else { return [] }
    };

    const fetchData = async () => {
        try {
            let finalData = [];
            let transformedArray = [];
            let networkData = [];
            let arrayOfAssetId = [];
            let finalHealthData = [];

            if (floorId) {
                finalData = await DevicesDetails(floorId);
                networkData = await networkDeviceDetails(floorId);
                // console.log("Network Data:", networkData);

                if (productType.includes('ONE')) {
                    arrayOfAssetId = networkData.map(networkinfo => networkinfo.assetId);
                } else {
                    arrayOfAssetId = finalData.map(deviceInfo => deviceInfo.assignedSpace?.assetId);
                }

            } else {
                const location = await LocationDetails();
                const arrayOfFloorId = location.filter(item => item.type === "FLOOR");

                const deviceDetailsPromises = arrayOfFloorId.map(async (floor) => {
                    try {
                        const deviceDetails = await DevicesDetails(floor.id); // Assuming DevicesDetails takes an id as an argument
                        const networkData = await networkDeviceDetails(floor.id);

                        let arrayOfAssetId;
                        if (productType.includes('ONE')) {
                            arrayOfAssetId = networkData.map(networkinfo => networkinfo.assetId);
                        } else {
                            arrayOfAssetId = deviceDetails.map(deviceInfo => deviceInfo.assignedSpace?.assetId);
                        }

                        const mergedDataArray = deviceDetails.map(deviceDetailsFinale => {
                            const networkDataDisplay = networkData.find(network => network.id === deviceDetailsFinale.id);
                            if (networkDataDisplay) {
                                deviceDetailsFinale.networkData = networkDataDisplay;
                            }
                            return deviceDetailsFinale;
                        });

                        return { mergedDataArray, arrayOfAssetId };
                    } catch (error) {
                        console.error('Error processing floor id:', floor.id, error);
                        return null; // Or handle the error as needed
                    }
                });

                const results = await Promise.all(deviceDetailsPromises);

                finalData = results.filter(result => result !== null).flatMap(result => result.mergedDataArray);
                arrayOfAssetId = results.filter(result => result !== null).flatMap(result => result.arrayOfAssetId);
                finalHealthData = await fetchHealth(arrayOfAssetId);

                // console.log("Final Data:", finalData);
                // console.log("All Asset IDs:", arrayOfAssetId);
                // console.log("Final Health Data:", finalHealthData);
            }

            const productWiseDetails = await productDetails();
            // console.log("Product Wise Details:", productWiseDetails);

            if (productType) {
                if (!finalData) {
                    throw new Error("finalData is undefined");
                }
                const filteredProductData = transformData(finalData, productWiseDetails, finalHealthData);
                // console.log("Filtered Product Data:", filteredProductData);
                transformedArray = filteredProductData.filter(item => productType.includes(item.Product));
            } else {
                transformedArray = transformData(finalData, productWiseDetails, finalHealthData);
            }

            setDevicesInfo(transformedArray);
        } catch (error) {
            console.error('Error in fetchData:', error);
        }
    };

    useEffect(() => {

        if (productType && productType.length > 0) {
            // console.log('ProductType', productType);
            fetchData();
        }
        //     console.log('productType', productType);
        //     // setLoading(true);
        //     fetchData();
        //     // setLoading(false);
        // } else {
        //     console.log('no productType', productType);
        // }
    }, [productType]);

    // if (loading) {
    //     return (
    //         <div style={{ height: '100vh', width: '100%', textAlign: 'center' }}>
    //             Loading...
    //         </div>
    //     );
    // }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <HealthOverviewContext.Provider
            value={{
                devicesInfo: devicesInfo,
                setProductType,
            }}>
            {children}
        </HealthOverviewContext.Provider >
    );
};

// Skip prop validation by setting propTypes to null
HealthOverviewProvider.propTypes = null;

export default HealthOverviewProvider;








